import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {ControlLabel, FormControl, FormGroup, HelpBlock, Col} from 'react-bootstrap';
import classNames from 'classnames';

export class InputField extends Component {
    static propTypes = {
        maxLength: PropTypes.number,
        tabTarget: PropTypes.any,
        type: PropTypes.string,
        controlId: PropTypes.string,
        placeholder: PropTypes.string,
        label: PropTypes.string,
        labelClass: PropTypes.string,
        required: PropTypes.bool,
        autoFocus: PropTypes.bool,
        autoComplete: PropTypes.string,
        help: PropTypes.node,
        meta: PropTypes.shape({
            touched: PropTypes.bool,
            error: PropTypes.string,
            warning: PropTypes.string,
        }),
        input: PropTypes.shape({
            value: PropTypes.any,
            name: PropTypes.string,
            onChange: PropTypes.func,
            onBlur: PropTypes.func,
        }),
        labelCol: PropTypes.object,
        fieldCol: PropTypes.object,
    };

    static defaultProps = {
        labelCol: {md: 3},
        fieldCol: {md: 9}
    };

    inputRef = () => {
        return this.input;
    };

    render() {
        const {
            input, controlId, meta, help, label, labelClass, required, labelCol, fieldCol, ...rest} = this.props;
        const {name, value, onChange, onBlur} = input;
        const {touched, error, warning} = meta;
        const validationState = touched ? (error ? 'error' : (warning ? 'warning' : null)) : null;

        let labelControl;
        if (label) {
            if (labelCol) {
                labelControl = <Col componentClass={ControlLabel} {...labelCol} className={classNames(labelClass, {required})}>{label}</Col>;
            } else {
                labelControl = <ControlLabel className={classNames(labelClass, {required})}>{label}</ControlLabel>;
            }
        }

        let fieldControl = (<div>
            <FormControl value={value} onChange={onChange} inputRef={c => this.input = c} onBlur={onBlur} {...rest}/>
            <FormControl.Feedback/>
            <HelpBlock>{touched && (error || warning || help)}</HelpBlock>
        </div>);
        if (fieldCol) {
            fieldControl = <Col {...fieldCol}>{fieldControl}</Col>;
        }

        return (
            <FormGroup controlId={controlId || name} validationState={validationState}>
                {labelControl}
                {fieldControl}
            </FormGroup>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/InputField.js